<template>
  <ul class="o-list-bare side-menu">
    <li v-for="(item, index) in items" :key="index" class="side-menu__item">
      <button-menu :icon="item.icon" :text="item.text" :active="item.active" />
    </li>
  </ul>
</template>

<script>
import ButtonMenu from '@/components/navs/button-menu'
export default {
  name: 'side-menu',

  components: { ButtonMenu },

  data() {
    return {
      items: [
        {
          active: true,
          icon: 'users',
          text: 'Usuarios'
        },
        {
          text: 'Mi Perfil'
        },
        {
          text: 'Probando un texto un poco más largo'
        },
        {
          text: 'Mi Perfil'
        },
        {
          text: 'Mi Perfil'
        },
        {
          text: 'Mi Perfil'
        },
        {
          text: 'Opciones'
        }
      ]
    }
  },
}
</script>
